export const addDays = (d: Date, n: number): Date => {
  const out = new Date(d)
  out.setUTCDate(out.getUTCDate() + n)
  return out
}

export const formatYMD = (d: Date): string => {
  const y = d.getUTCFullYear()
  const m = String(d.getUTCMonth() + 1).padStart(2, '0')
  const day = String(d.getUTCDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export const isoDate = formatYMD

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
] as const

export const formatMonthYear = (d: Date): string =>
  `${MONTH_NAMES[d.getUTCMonth()]} ${d.getUTCFullYear()}`

export const daysInMonth = (year: number, month1Based: number): number =>
  new Date(Date.UTC(year, month1Based, 0)).getUTCDate()

export const formatMonDayYear = (d: Date): string =>
  `${MONTH_NAMES[d.getUTCMonth()]!.slice(0, 3).toUpperCase()} ${d.getUTCDate()}, ${d.getUTCFullYear()}`

export const formatClosedStamp = (d: Date): string => {
  const mon = MONTH_NAMES[d.getUTCMonth()]!.slice(0, 3)
  return `Closed ${mon} ${d.getUTCDate()}, ${d.getUTCFullYear()} · 2:47 PM`
}
